import { SESSION_FORCED_VARIATIONS } from '../constants';

type ForcedVariations = {
  [campaignId: string]: number;
};

export const changeVariation = (testId: number, value: number, shouldReload: boolean) => {
  if (isNaN(testId) || isNaN(value)) return;

  const forcedVariations: ForcedVariations = JSON.parse(
    window.sessionStorage.getItem(SESSION_FORCED_VARIATIONS) || '{}'
  );
  forcedVariations[testId] = value;
  window.sessionStorage.setItem(SESSION_FORCED_VARIATIONS, JSON.stringify(forcedVariations));

  if (shouldReload) window.location.reload();
};
